import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import AddressControl from '../../form/AddressControl';
import createForm from "./Form";
import DateTimeInput from "../../form/DateTimeInput";
import {ifCompletedInput} from "../../../utils/other";
import {CurrencyFormatter, optionsTemplate, ProductColumn, UnitFormatter} from "../../../utils/formatters";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";

const sortable = true;
const filterable = true;

class ProductionForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-4">
                        <Select
                            {...this.props.getFieldProps("product_id")}
                            name="product_id"
                            component="product"
                            objectValue={false}
                            optionsTemplate={optionsTemplate("product")}
                            storeType="remote"
                            saveChanges={this.props.setFieldValue}
                            value={this.props.values.product_id}
                            label="Termék"
                        />
                    </div>
                    <div className="col-md-4">
                        <TextInput
                            type="number"
                            name="qty"
                            label="Darabszám"
                            value={this.props.values.qty}
                            {...this.props.getFieldProps("qty")}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-4">
                        <DateTimeInput
                            name="productiondate"
                            label="Gyártás dátuma"
                            {...this.props.getFieldProps("productiondate")}
                            value={this.props.values.productiondate}
                            showTime={false}
                            saveChanges={this.props.setFieldValue}/>
                    </div>
                </div>
                <Fragment>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <SelectorGrid
                                {...this.props.getFieldProps("items")}
                                ref={(e) => this.items = e}
                                className={"p-small-table"}
                                view={["id", "name", "qty", "product_id"]}
                                columns={{
                                    "id": {
                                        header: 'Kód',
                                        width: 1,
                                        sortable,
                                        filterable
                                    },
                                    "displayname": {
                                        ...ProductColumn("product_id"),
                                        width: 9,
                                    },
                                    "barcode": {
                                        header: 'Vonalkód',
                                        width: 1,
                                        sortable,
                                        filterable
                                    },
                                    "qty": {
                                        header: 'Darabszám',
                                        width: 2,
                                        sortable,
                                        filterable,
                                        renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                                        className: "unit"
                                    }
                                }}
                                aggregations={{
                                    fields: {
                                        "qty": {
                                            field: "qty", type: "SUM"
                                        }
                                    }
                                }}
                                listfield="items"
                                data={this.props.values}
                                orderBy={{field: "displayname", direction: "ASC"}}
                                componentConfig={this.props.componentConfig}
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <label className="control-label">Költségek</label>
                            <SelectorGrid
                                {...this.props.getFieldProps("expenses")}
                                ref={(e) => this.expenses = e}
                                className={"p-small-table"}
                                view={["id", "name", "qty", "product_id"]}
                                columns={{
                                    "id": {
                                        header: 'Kód',
                                        width: 1,
                                        sortable,
                                        filterable
                                    },
                                    "expense_type.name": {
                                        header: 'Jogcím',
                                        width: 4,
                                        sortable,
                                        filterable
                                    },
                                    "expense_payment.seller.name": {
                                        header: 'Partner',
                                        width: 4,
                                        sortable,
                                        filterable
                                    },
                                    "net_amount": {
                                        header: 'Nettó',
                                        width: 2,
                                        sortable,
                                        filterable,
                                        renderer: CurrencyFormatter,
                                        className: "currency",
                                    },
                                    "expense_type.vat.name": {
                                        header: 'Áfa',
                                        width: 1,
                                        sortable,
                                        filterable
                                    },
                                    "amount": {
                                        header: 'Bruttó',
                                        width: 2,
                                        sortable,
                                        filterable,
                                        renderer: CurrencyFormatter,
                                        className: "currency",
                                    },
                                }}
                                listfield="expenses"
                                data={this.props.values}
                                componentConfig={this.props.componentConfig}
                            />
                        </div>
                    </div>
                </Fragment>
            </form>
        );
    }
}

export default createForm(ProductionForm);
